import { PageHeading } from './components/PageHeading/PageHeading';
import { RecentlyViewedStorefronts } from './components/RecentlyViewedStorefronts/RecentlyViewedStorefronts';
import { SearchControls } from './components/SearchControls/SearchControls';
import { VendorSearchResultsGrid } from './components/VendorSearchResultsGrid/VendorSearchResultsGrid';
import { StickyScrollProvider, useStickyScrollContext } from './contexts/StickyScrollContext';
import { VendorGridCardsProvider } from './contexts/VendorGridCardsProvider';

const Hed = () => {
  const { isStickyActive } = useStickyScrollContext();

  return <PageHeading shouldCloseDropdowns={isStickyActive} />;
};

export const SearchResultsContent = () => {
  return (
    <StickyScrollProvider>
      <Hed />
      <SearchControls />
      <RecentlyViewedStorefronts />
      <VendorGridCardsProvider>
        <VendorSearchResultsGrid />
      </VendorGridCardsProvider>
    </StickyScrollProvider>
  );
};
